import { MdClose } from 'react-icons/md'

export const CloseIcon = (props: any) => <MdClose {...props} />
